<section class="hero-bg">
    <div class="sm:min-h-[400px] relative max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-4 px-5 py-16 sm:py-20">
        <div class="text-center flex-1">
            <h1 *ngIf="title" class="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-turquoise">
                {{ title }}
            </h1>
    
            <p *ngIf="subtitle" class="mt-6 text-lg leading-8 text-gray-300">
                {{ subtitle }}
            </p>
        </div>
    </div>
</section>